"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UrlUtil = void 0;
exports.UrlUtil = {
    getUrlParameter: function (search, name) {
        // eslint-disable-next-line no-useless-escape
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    },
    /**
     * Determines whether or not the provided url is a localhost address.
     * @param url The url to check.
     * @returns `true` if the provided url is a localhost address, otherwise `false`.
     */
    isLocalhost: function (url) { return url.hostname === 'localhost' || url.hostname === '127.0.0.1' || url.hostname === '[::1]'; },
};
